const FORM_TO_GOBODO_FIELD: Record<string, string> = {
  spouse: 'Spouse__c',
  primaryParent: 'Primary_Parent__c',
  accountManager: 'Contact__c',
  accountManagerCompany: 'Account_Manager_Company__c',
  dayToDayContact: 'Daily_Contact__c',
  managingFirm: 'Service_Management__c',
};

const RELATIONSHIP_FIELDS = new Set(['Spouse__c', 'Primary_Parent__c']);
const SF_ACCOUNT_ID_RE = /^001[A-Za-z0-9]{12,15}$/;

type LookupSelection = {
  key?: unknown;
  label?: unknown;
};

export type CreditBlockLookupSavePayload = {
  gobodoFieldName: string;
  coercedValue: unknown;
};

function unwrapLookupSelection(value: unknown): unknown {
  if (value && typeof value === 'object' && !Array.isArray(value) && 'key' in (value as LookupSelection)) {
    return String((value as LookupSelection).key ?? '');
  }
  return value;
}

export function buildCreditBlockLookupSavePayload(
  fieldName: string,
  value: unknown,
  suffix: string
): CreditBlockLookupSavePayload {
  const gobodoFieldName = FORM_TO_GOBODO_FIELD[fieldName] ?? fieldName;
  let coercedValue = unwrapLookupSelection(value);

  if (RELATIONSHIP_FIELDS.has(gobodoFieldName) && typeof coercedValue === 'string') {
    const trimmed = coercedValue.trim();
    const alreadySuffixed = suffix && trimmed.toLowerCase().endsWith(suffix.toLowerCase());
    if (SF_ACCOUNT_ID_RE.test(trimmed) && !alreadySuffixed) {
      coercedValue = `${trimmed}${suffix}`;
    } else {
      coercedValue = trimmed;
    }
  }

  return { gobodoFieldName, coercedValue };
}
